import { Theme, css } from '@emotion/react';
import { ToggleButtonGroupProps } from './ToggleButtonGroup';

export const toggleButtonGroupRoot =
  (fullWidth: ToggleButtonGroupProps['fullWidth']) =>
  ({ spacing }: Theme) => css`
    ${fullWidth &&
    `
		display: flex;
		& > * {
			flex: 1 0 auto;
		}
	`}
  `;
